<template>
  <div>
    <nav>
      <v-app-bar flat app color="rgb(0, 112, 177)" dark>
        <v-app-bar-nav-icon class="white--text d-flex d-lg-none" @click="movil"></v-app-bar-nav-icon>
        <v-app-bar-nav-icon class="white--text d-none d-lg-flex" @click="cambiarEstado"></v-app-bar-nav-icon>
        <!--Titulo Navbar-->
        <v-app-bar-title disabled class="text-uppercase text-subtitle-1">
          Bombas y suministros del norte
        </v-app-bar-title>
        <!--/Titulo Navbar-->

        <v-spacer></v-spacer>

        <!-- Derecha Navbar-->
        <v-btn v-if="sesionIniciada" class="btn" text @click="cerrarSesion">
          <span class="d-none d-sm-flex">Cerrar Sesion.</span>
          <v-icon right>mdi-exit-to-app</v-icon>
        </v-btn>

        <v-btn v-else to="/login" class="btn"  text color="">
          <span>Iniciar sesion.</span>
          <v-icon right>mdi-exit-to-app</v-icon>
        </v-btn>

        
        <!--/ Derecha Navbar-->

      </v-app-bar>

        <!-- Barra lateral izquierda -->

      <v-navigation-drawer v-model="barraLateral" :mini-variant.sync="mini" app class="elevation-3">
        <v-list-item dark style="background-color:rgb(0, 112, 177);">
          <v-list-item-content>
            <v-list-item-title class="text-h6"> App bombas </v-list-item-title>
            <v-list-item-subtitle class="white--text"> {{ getUsuario }}  </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list dense nav>
          <v-list-item link to="/dashboard">
            <v-list-item-icon>
              <v-icon>mdi-view-dashboard</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Modulos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/usuarios" v-if="getRolesUsuario.includes('SA')">
            <v-list-item-icon>
              <v-icon>mdi-account-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Usuarios</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/Proyecto" v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || getRolesUsuario.includes('AUTO') || getRolesUsuario.includes('CAP') || getRolesUsuario.includes('CON')  ">
            <v-list-item-icon>
              <v-icon  color="grey darken-1">mdi-application-edit</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Proyectos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/requisicion" v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || getRolesUsuario.includes('AUTO') || getRolesUsuario.includes('CAP') || getRolesUsuario.includes('CON') ">
            <v-list-item-icon>
              <v-icon  color="grey darken-1">mdi-folder-plus-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Requisiciones</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/pedidos" v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || getRolesUsuario.includes('AUTO') ">
            <v-list-item-icon>
              <v-icon  color="grey darken-1">mdi-package-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Pedidos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/despiece" v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || getRolesUsuario.includes('AUTO') || getRolesUsuario.includes('CAP') || getRolesUsuario.includes('TALL') ">
            <v-list-item-icon>
              <v-icon  color="grey darken-1">mdi-paperclip</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Despiece</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/OrdenesDeCompra" v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || getRolesUsuario.includes('AUTO')">
            <v-list-item-icon>
              <v-icon  color="grey darken-1">mdi-order-bool-ascending-variant</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Órdenes de compra</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/maquinado" v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || getRolesUsuario.includes('AUTO') || getRolesUsuario.includes('CAP') || getRolesUsuario.includes('TALL') || getRolesUsuario.includes('MAQ') ">
            <v-list-item-icon>
              <v-icon  color="grey darken-1">mdi-toolbox</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Maquinado</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/salidaProcesos" v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || getRolesUsuario.includes('AUTO') || getRolesUsuario.includes('CAP') || getRolesUsuario.includes('TALL') ">
            <v-list-item-icon>
              <v-icon>mdi-application-export</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Resguardo</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item link to="/reportes" v-if="getRolesUsuario.includes('SA') || getRolesUsuario.includes('ADMIN') || getRolesUsuario.includes('AUTO')">
            <v-list-item-icon>
              <v-icon>mdi-microsoft-excel</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Reportes</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          
        </v-list>
      </v-navigation-drawer>

      <!--/ Barra lateral izquierda -->

    </nav>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'


export default {

  
  data() {

    return {

      barraLateral: true,
      mini:true,
      nuevo:false,
    };

  },

  
  computed: {

    ...mapGetters([ 'sesionIniciada' , 'getUsuario' , 'getRolUsuario','getRolesUsuario' ])

  },

  
  methods: {

    cambiarEstado(){
      // this.barraLateral= !this.barraLateral;
      this.mini = !this.mini;
    },
    movil(){
      this.barraLateral = true
      this.mini = false
    },
    cerrarSesion () {
      this.$store.dispatch('cerrarSesion')
    },

  },


};

</script>

<style>
</style>
